import app from './app';

export default function handleError(error: Error | string) {
	app('errorHandler').handle(error);
}
